import React, { useEffect } from 'react';
import { Container } from '@skf/bt-wind-rail-commonlibrary';
import { useLoadingScreen } from '../../../hooks/useLoadingScreen';

export const Unauthorized: React.FunctionComponent = () => {
  const { setLoading } = useLoadingScreen();

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <div>
      <Container>
        <h2>
          You are not authorized to view this content. <br />
          Please contact the administrator.
        </h2>
      </Container>
    </div>
  );
};
